import { useEffect, useState } from 'react'
import { format } from 'date-fns'
import { useInterval } from 'react-use';
import { ReactComponent as BERRY_AI_LOGO } from '../assets/images/Berry_AI_logo.svg'
import { MdLogout } from 'react-icons/md'
import classNames from 'classnames';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import ConfirmModal from './modals/Confirm';
import packageJson from '../../package.json'
import * as Sentry from '@sentry/react'
import axios from 'axios';
import { detectOS } from '../utils';

type HeaderProps = {
  data?: {
    interval: string,
    start: string,
    end: string,
    brandName: string,
    thirdparty: string[],
    hideButton: boolean,
  }
}

function Header({ data }: HeaderProps) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [open, setOpen] = useState(false)
  const branch_id = searchParams.get('branch_id');

  useInterval(() => {    
    var bodyFormData = new FormData();
    bodyFormData.append('branch_id', branch_id ?? '');
    bodyFormData.append('user_agent', window.navigator.userAgent ?? '');
    bodyFormData.append('platform', window.navigator.platform ?? '');
    bodyFormData.append('version', packageJson.version ?? '');
    bodyFormData.append('path', location.pathname ?? '');
    bodyFormData.append('os', detectOS())
    bodyFormData.append('product', 'leader-board')
    bodyFormData.append('name', 'HEARTBEAT')
    
    axios({
      method: 'POST',
      url: 'https://mo.airocks.dev/api/heartbeat',
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    }).then(res => console.log(res))
    console.log(`${branch_id} | ${packageJson.version} | ${location.pathname} | LIFE CHECK`)
    Sentry.captureMessage(`${branch_id} | ${packageJson.version} | LIFE CHECK`)
    
  }, 60 * 60 * 1000)

  const logout = () => {
    setOpen(false);
    navigate(`/?id=${searchParams.get('id')}`);
    console.log(`${branch_id} | ${packageJson.version} | ${location.pathname} | LOGOUT`)
    Sentry.captureMessage(`${branch_id} | ${packageJson.version} | LOGOUT`)
  }

  const showModal = () => {
    setOpen(true);
  }

  const closeModal = () => {
    setOpen(false);
  }

  return (
    <div className="h-9 bg-white flex items-center justify-between relative z-50 flex-shrink-0">
      <div className="flex flex-1 gap-2 items-center pl-4">
        <BERRY_AI_LOGO className="h-[24px]" />
        {data && <div className='text-sm leading-5 font-bold text-gray-700'>{data.brandName}</div>}
      </div>
      {data && data.thirdparty.length === 0 && <div className='flex items-center gap-1 flex-shrink-0'>
        <div className='text-xl leading-7 font-bold text-gray-700'>{data.interval}</div>
        <div className='text-sm leading-5 font-bold text-gray-700'>{`(${data.start} - ${data.end})`}</div>
      </div>}
      <div className={classNames({ "pr-4": !data }, "flex flex-1 items-center justify-end flex-shrink-0")}>
        {/* {data && data.thirdparty.length !== 0 && data.dataUpdatedAt !== null && <div className="leading-tight flex gap-2 items-center">
          <span><FaRegClock /></span>
          <span className='mr-2'>{format(data.dataUpdatedAt, 'yyy-MM-dd HH:mm:ss')}</span>
        </div>} */}
        {data && !data.hideButton &&
        <div className='h-9 w-9 bg-red-main ml-1 text-white flex items-center justify-center cursor-pointer' onClick={showModal}>
          <MdLogout size={20} />
        </div>}
        <ConfirmModal
          open={open}
          onClose={closeModal}
          onConfirm={logout}
          content={
            <div className="font-bold text-xl text-gray-700">Please confirm to logout</div>
          }
        />
      </div>
    </div>)
}

export default Header
